// src/components/Blog/BlogList.jsx
import React from "react";
import { Link } from "react-router-dom";
import blogIndex from "./blogs/blogData.json";

const BlogList = () => {
  const posts = [...blogIndex].sort((a, b) => (b.date || "").localeCompare(a.date || ""));

  return (
    <div className="max-w-6xl mx-auto px-5 py-10">
      <h1 className="text-4xl font-bold mb-8 text-center">MyBOQ Blog</h1>

      {posts.length === 0 ? (
        <div className="text-center text-gray-500">No posts yet.</div>
      ) : (
        <div className="grid md:grid-cols-2 gap-6">
          {posts.map((blog) => {
            const to = `/blog/${blog.slug}`;
            const thumb = blog.thumbnail || "/images/blog/placeholder.jpg";
            return (
              <article
                key={blog.slug}
                className="border rounded-2xl shadow hover:shadow-lg transition bg-white overflow-hidden"
              >
                <Link to={to} aria-label={`Read: ${blog.title}`}>
                  {/* Keep grid tidy with fixed ratio */}
                  <div className="aspect-[16/9] w-full overflow-hidden">
                    <img
                      src={thumb}
                      alt={blog.title}
                      loading="lazy"
                      decoding="async"
                      className="w-full h-full object-cover"
                      onError={(e) => { e.currentTarget.src = "/images/blog/placeholder.jpg"; }}
                    />
                  </div>
                </Link>

                <div className="p-5">
                  <div className="text-xs text-gray-500">
                    {blog.date || ""} {blog.reading_time ? `• ${blog.reading_time}` : ""}
                  </div>

                  <h2 className="text-xl font-semibold mt-1">
                    <Link to={to} className="hover:text-orange-700">
                      {blog.title}
                    </Link>
                  </h2>

                  {/* If you enabled @tailwindcss/line-clamp, keep line-clamp-3; otherwise remove it */}
                  <p className="text-gray-600 mt-2 line-clamp-3">{blog.excerpt}</p>

                  <Link
                    to={to}
                    className="text-orange-600 mt-4 inline-block hover:text-orange-700 font-semibold"
                  >
                    Read More →
                  </Link>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default BlogList;
